/* eslint-disable import/prefer-default-export */
import { InvalidScopesError } from './invalid-scope-error'

export class ScopesService {
  private readonly requiredScopes: string[]

  constructor(requiredScopes: string[]) {
    this.requiredScopes = requiredScopes
  }

  validateScopes(currentScopes: string[]): Boolean {
    const missingScopes = this.requiredScopes.filter((scope) => !currentScopes.includes(scope))

    if (missingScopes.length === 0) return true

    // eslint-disable-next-line no-console
    console.log('Missing scopes:', missingScopes)
    throw new InvalidScopesError()
  }
}
